(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/modular-base/assets/javascripts/skeleton/skeleton-parts/wager-skeleton.receipt.js') >= 0) return;  svs.modules.push('/components/tipsen/modular-base/assets/javascripts/skeleton/skeleton-parts/wager-skeleton.receipt.js');
"use strict";

const Paper = svs.ui.ReactPaper;
const SkeletonLine = svs.components.lbUi.SkeletonLine;
const WagerSkeletonReceipt = () => React.createElement(Paper, {
  branding: "sport",
  className: "pg_my_bets_wager_fallback__grid__receipt"
}, React.createElement(SkeletonLine, {
  className: "pg_my_bets_wager_fallback__grid__receipt__text"
}));
setGlobal('svs.components.tipsen.modularBase.WagerSkeletonReceipt', WagerSkeletonReceipt);

 })(window);